import styled from "styled-components"

export default {
    "Main": styled.main`
        flex-grow: 1;
        background-color: ${({ theme }) => theme.color.grey1};
        padding: 40px;
    `
}